<mat-form-field
  appearance="outline"
  class="w-100 miBoton"
  style="height: 100% !important"
>
  <input
    matInput
    [matDatepicker]="dp"
    [readonly]="true"
    placeholder="Mes/Año"
    [(ngModel)]="value"
  />

  <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
  <button
    *ngIf="value"
    mat-icon-button
    matSuffix
    aria-label="Resetear fecha"
    (click)="reset()"
  >
    <mat-icon>
      <i-tabler name="X" class="icon-20 d-flex"></i-tabler>
    </mat-icon>
  </button>

  <mat-datepicker
    #dp
    startView="multi-year"
    (monthSelected)="chosenMonthHandler($event, dp)"
    [startAt]="value"
    [touchUi]="true"
    panelClass="month-picker"
  ></mat-datepicker>
</mat-form-field>
